import { render } from "./MessageAtualizar.vue?vue&type=template&id=1ece5554"
import script from "./MessageAtualizar.vue?vue&type=script&lang=js"
export * from "./MessageAtualizar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DealDesk\\Homologação\\Mult_Cliente\\front_mult_clint\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__